<div class="gallery-component-container">

    <div class="gallery-images-container">
        <div class="row">
            <div *ngFor="let image of currentImagesShowing" class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 col-xxl-3 px-1 mt-2">
                <div class="card">
                    <div class="card-img-container" (mouseenter)="hoverImage(image)" (focus)="hoverImage(image)" (mouseout)="dehoverImage(image)" (blur)="dehoverImage(image)" [ngClass]="{ 'box-shadow' : isImageSelected(image) && isSelectable }">
                        <img #galleryImage src="{{ image }}" class="card-img-top" (click)="selectImage(image)" [ngStyle]="setFallBackStyle(galleryImage)" />
                        <div class="gallery-image-selected mr-2 mb-2">
                            <mat-checkbox *ngIf="isSelectable" class="gallery-image-selected-checkbox" (change)="selectImage(image)" [checked]="isImageSelected(image)"></mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfImages > amountToDisplayCurrently">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="gallery-show-more-btn" (click)="showMoreImages()">
                <span i18n="@@gallery-show-more-images">Show more images</span>
                <i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i>
            </button>
        </div>
    </div>
    <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfImages <= amountToDisplayCurrently && fetchedAmountOfImages > amountToDisplay">
        <div class="col-auto">
            <button mat-flat-button color="accent" class="gallery-show-less-btn" (click)="showLessImages()">
                <span i18n="@@gallery-show-less-images">Show less images</span>
                <i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i>
            </button>
        </div>
    </div>

</div>



